<template>
  <aside :class="['main-sidebar', 'col-12', 'col-md-3', 'col-lg-2', 'px-0', sidebarVisible ? 'open' : '']">
      <div class="main-navbar logo">
        <nav class="navbar align-items-stretch navbar-light bg-white flex-md-nowrap border-bottom p-0">
          <a class="navbar-brand w-100 h-100 mr-0" href="#" style="line-height: 25px;">
            <div class="d-table m-auto text-center">
              <img
                id="main-logo"
                class="d-inline-block align-top mr-1"
                style="max-height: 38px; max-width: 80%"
                src="@/assets/images/logo.png"
                alt="Sistema de gerenciamento">
            </div>
          </a>
          <a class="toggle-sidebar d-sm-inline d-md-none d-lg-none text-white" @click="handleToggleSidebar()">
            <i class="material-icons">&#xE5C4;</i>
          </a>
        </nav>
      </div>

      <div class="nav-wrapper">
          <d-nav class="flex-column">
            <li v-for="(item, navItemIdx) in menu" :key="navItemIdx" class="nav-item dropdown">
              <d-link :class="['nav-link', item.items && item.items.length ? 'dropdown-toggle' : '']" :to="item.to" v-d-toggle="`snc-${navItemIdx}`" @click="handleToggleSidebar()">
                <div class="item-icon-wrapper" v-if="item.htmlBefore" v-html="item.htmlBefore" />
                <span v-if="item.title">{{ item.title }}</span>
                <div class="item-icon-wrapper" v-if="item.htmlAfter" v-html="item.htmlAfter" />
              </d-link>
              <d-collapse v-if="item.items && item.items.length" :id="`snc-${navItemIdx}`" class="dropdown-menu dropdown-menu-small" accordion="sidebar-items-accordion">
                <d-link class="dropdown-item nav-link" v-for="(subItem, subItemIdx) in item.items" :key="subItemIdx" :href="subItem.href" :to="subItem.to" @click="handleToggleSidebar()">
                  {{ subItem.title }}
                </d-link>
              </d-collapse>
            </li>
          </d-nav>
      </div>
  </aside>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import SessionService from '_services/common/sessionService';

export default {
  name: 'main-sidebar',
  props: {
    /**
      * Whether to hide the logo text, or not.
      */
    hideLogoText: {
      type: Boolean,
      default: false,
    },
    /**
     * The menu items.
     */
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    menu() {
      if (this.isCustomer) {
        return this.items.filter(item => {
          if (item.items && item.items.length > 0) {
            item.items = item.items.filter(subItem => this.checkAccess(subItem));
          }
          return this.checkAccess(item) && item.name === 'customers';
        });
      }
      return this.items.filter(item => this.modules.includes(item.name) || item.name === 'dashboard');
    },
    userCustomersList() {
      return this.$store.state.user.userCustomersList;
    },
    isCustomer() {
      const { isCustomer } = this.$store.state.user;
      return isCustomer;
    },
  },
  data() {
    return {
      sidebarVisible: false,
      modules: [],
    };
  },
  methods: {
    ...mapActions([
      'checkCustomer',
    ]),
    handleToggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },
    checkAccess(item) {
      if (this.isCustomer) {
        return this.checkAccessCustomer(item);
      }
      return true;
    },
    checkAccessCustomer(item) {
      try {
        if (item.isCustomer === false) {
          return false;
        }
        if (this.isCustomer) {
          if (item.name === 'customers' && this.userCustomersList.length === 1) {
            item.to.name = 'admin-customer-edit';
            item.to.params = { customerId: this.userCustomersList[0].id };
            item.path = `/admin/clientes/${this.userCustomersList[0].id}`;
          }
        }
      } catch (error) {
        console.error(error);
      }
      return true;
    },
  },
  created() {
    this.checkCustomer();
    const { modules } = SessionService.getLocalData('_user');
    this.modules = modules.map(module => module.slug);
    this.$eventHub.$on('toggle-sidebar', this.handleToggleSidebar);
    Events.$on('sidebarVisible', sidebarVisible => { this.sidebarVisible = sidebarVisible; });
  },
  beforeDestroy() {
    this.$eventHub.$off('toggle-sidebar');
  },
};
</script>

<style lang="scss">
  .main-sidebar {
    .item-icon-wrapper {
      display: inline-block;
    }
    .dropdown-menu {
      display: block;
    }
  }
</style>
